import * as React from "react";
import { toast } from "sonner";
import moment from "./Moment";

const DATE_FORMAT = "dddd, MMMM DD, YYYY [at] h:mm A";

export default class Notification {
  static notifySuccess(text: string) {
    toast.success(text, { description: moment().format(DATE_FORMAT) });
  }

  static notifyWarning(text: string) {
    toast.warning(text, { description: moment().format(DATE_FORMAT) });
  }

  static notifyError(text: string, onClick?: () => void) {
    toast.error(
      onClick
        ? React.createElement(
            "span",
            { onClick, style: { cursor: "pointer" } },
            text,
          )
        : text,
      { description: moment().format(DATE_FORMAT) },
    );
  }

  static notifyInfo(text: string) {
    toast.info(text, { description: moment().format(DATE_FORMAT) });
  }
}
